import React, { useState } from 'react';
import { DocumentTextIcon, GlobeAltIcon, AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import AIEnhancer from './duzenleme/AIEnhancer';
import DetaylarModal from './duzenleme/DetaylarModal';

const HeaderCard = ({
  baslik,
  onAIGelistir,
  gorunumModu,
  setGorunumModu,
  activeTab,
  setActiveTab,
  icerik,
  tumEtiketler,
  tumKanunMaddeleri,
  duzenlenmisSablon,
  kategoriler,
  handleChange,
  handleSelectChange,
  onSave
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        {/* Önizle / Düzenle geçişi */}
        <div className="app-segment">
          <button
            type="button"
            onClick={() => setActiveTab('onizle')}
            className={`app-segment-item ${activeTab === 'onizle' ? 'app-segment-item-active' : ''}`}
          >
            Önizle
          </button>
          <button
            type="button"
            onClick={() => setActiveTab('duzenle')}
            className={`app-segment-item ${activeTab === 'duzenle' ? 'app-segment-item-active' : ''}`}
          >
            Düzenle
          </button>
        </div>

        <h2 className="order-last w-full break-words text-center font-display text-lg font-semibold text-slate-800 sm:order-none sm:w-auto sm:flex-1">
          {baslik}
        </h2>

        <div className="flex items-center gap-3">
          <AIEnhancer
            icerik={icerik}
            onEnhance={onAIGelistir}
            tumEtiketler={tumEtiketler}
            tumKanunMaddeleri={tumKanunMaddeleri}
          />
          <button
            type="button"
            onClick={toggleModal}
            className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-500 transition-colors hover:bg-slate-100 hover:text-amber-600"
            title="Detaylar"
            aria-label="Detayları düzenle"
          >
            <AdjustmentsHorizontalIcon className="h-5 w-5" />
          </button>
          <div className="h-6 w-px bg-slate-200" />
          <div className="app-segment">
            <button
              type="button"
              onClick={() => setGorunumModu('sayfa')}
              className={`app-segment-item flex items-center ${gorunumModu === 'sayfa' ? 'app-segment-item-active' : ''}`}
              title="Sayfa Görünümü"
              aria-label="Sayfa görünümü"
            >
              <DocumentTextIcon className="h-5 w-5" />
            </button>
            <button
              type="button"
              onClick={() => setGorunumModu('web')}
              className={`app-segment-item flex items-center ${gorunumModu === 'web' ? 'app-segment-item-active' : ''}`}
              title="Web Görünümü"
              aria-label="Web görünümü"
            >
              <GlobeAltIcon className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <DetaylarModal
          duzenlenmisSablon={duzenlenmisSablon}
          kategoriler={kategoriler}
          handleChange={handleChange}
          handleSelectChange={handleSelectChange}
          kayitliEtiketler={tumEtiketler}
          kayitliKanunMaddeleri={tumKanunMaddeleri}
          onClose={toggleModal}
          onSave={onSave}
        />
      )}
    </>
  );
};

export default HeaderCard;
